import React, { useRef } from 'react';
import Select from 'react-select';
import useSetState from '../../../../hooks/useSetState';
import ShowForPermission from '../../../../components/ShowForPermission';
import DatePicker from '../../../../components/FormElements/DatePicker/DatePicker';
import ENUMS from '../../../../enums';

const ReservationTimingFilter = ({ data, pageNumber, pageSize, applyFilters, getReservationList, resetForm }) => {
  let formRefrence = useRef();
  const [controls, setControls] = useSetState({
    cafeIds: [],
    fromDate: '',
    toDate: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const cafeList = data => {
    const listItems = data.map(cafe => ({
      label: cafe.name,
      value: cafe.id,
    }));
    return listItems;
  };

  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event, controls.cafeIds);
  };

  const onReset = () => {
    onChangeValue('fromDate', ' ');
    onChangeValue('toDate', ' ');
    onChangeValue('cafeIds', []);
    resetForm();
    getReservationList(pageNumber, pageSize);
  };

  return (
    <section>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id="filterForm"
        className="card card my-4">
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1">
            <div className="d-flex col-lg-3 col-md-12 col-sm-12 mx-1">
              <label className="rsee-form-label col-lg-5">{locales('fields.startDate')}</label>
              <div className="full-width">
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.startDate')}
                  name="fromDate"
                  onChange={val => onChangeValue('fromDate', val)}
                  value={controls.fromDate}
                  className="date-picker-input"
                />
              </div>
            </div>
            <div className="d-flex col-lg-3 col-md-12 col-sm-12 mx-1">
              <label className="rsee-form-label col-lg-4">{locales('fields.endDate')}</label>
              <div className="full-width">
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.endDate')}
                  name="toDate"
                  onChange={val => onChangeValue('toDate', val)}
                  value={controls.toDate}
                  className="date-picker-input"
                />
              </div>
            </div>
            <div className="d-flex col-lg-5 col-md-12 col-sm-12 mx-1">
              <ShowForPermission
                permission={ENUMS.PERMISSIONS.values.AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES}>
                <label className="rsee-form-label">{locales('fields.cafe')}</label>
                <div className="full-width">
                  <Select
                    id="cafeIds"
                    name="cafeIds"
                    placeholder={locales('fields.cafe.name')}
                    isMulti={true}
                    options={cafeList(data)}
                    onChange={e => onChangeValue('cafeIds', e)}
                    value={controls.cafeIds}
                  />
                </div>
              </ShowForPermission>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0 my-3">
            <button type="button" onClick={onReset} className="btn btn-danger w-5 mx-2">
              {locales('fields.reset')}
            </button>
            <button type="submit" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>

        </main>
      </form>
    </section >
  );
}

export default ReservationTimingFilter;